<template>
  <span class="multiselect-wrapper">
    <multiselect
      :value="selectedItem"
      track-by="definition"
      :placeholder="$t('task.priority.text')"
      :options="options"
      :searchable="false"
      :allow-empty="false"
      :show-labels="false"
      @select="itemSelected($event)"
      :disabled="disabled"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <task-priority :priority="option.definition" size="13" />
      </template>
      <template slot="option" slot-scope="{ option }">
        <task-priority :priority="option.definition" size="13" />
      </template>
    </multiselect>
  </span>
</template>

<script>
export default {
  props: ["selected", "disabled"],
  data() {
    return {
      selectedItem: undefined,
    };
  },
  computed: {
    options() {
      const language = this.account.language;
      return [
        {
          definition: "1",
          name: {
            [language]: this.$t("task.priority.low"),
          },
        },
        {
          definition: "2",
          name: {
            [language]: this.$t("task.priority.medium"),
          },
        },
        {
          definition: "3",
          name: {
            [language]: this.$t("task.priority.high"),
          },
        },
        {
          definition: "4",
          name: {
            [language]: this.$t("task.priority.highest"),
          },
        },
      ];
    },
    account() {
      return this.$store.getters["user/account"];
    },
  },
  watch: {
    selected: {
      immediate: true,
      handler(v) {
        this.selectedItem = this.options.find((i) => i.definition == v) || this.options[1];
      },
    },
  },
  mounted() {},
  methods: {
    itemSelected(item) {
      this.selectedItem = item;
      if (item) {
        this.$emit("onSelect", item.definition);
      } else {
        this.$emit("onSelect", "MEDIUM");
      }
    },
  },
};
</script>

<style>
.multiselect-wrapper .multiselect__option--highlight {
  background: rgb(237, 237, 237) !important;
  color: black !important;
}
</style>
